var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.render_html)?_c('span',{staticClass:"table__field-filtered",domProps:{"innerHTML":_vm._s(_vm.field_filtered)}}):_c('span',{staticClass:"table__field-filtered"},[_vm._v(" "+_vm._s(_vm.field_filtered)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }